import React, { useState } from 'react';
import cross from '../images/ImageUpload/cross.png'
import PanoramaViewer from './PanoramaViewer'

function ModalImage({ imageUrl, onClose, mobile }) {

  return (
    <div
      className="w-screen h-screen absolute inset-0 flex justify-center items-center bg-[#000] bg-opacity-75 p-10 z-[8888] overflow-hidden"
      onClick={onClose}
    >
      <div className="w-full h-full flex justify-center items-center relative">

        <img
          src={imageUrl}
          alt="Modal"
          className="max-w-full max-h-full object-contain w-auto h-auto"
        />

        <div
          className="absolute right-0 top-0 rounded-full flex justify-center items-center bg-white p-0 cursor-pointer"
          onClick={onClose}
        >
          <img className="w-10" src={cross} alt="" />
        </div>

      </div>
    </div>

  );
}

export default ModalImage;